import { render, staticRenderFns } from "./ModalOptionConfig.vue?vue&type=template&id=eca96e14&scoped=true&"
import script from "./ModalOptionConfig.vue?vue&type=script&lang=js&"
export * from "./ModalOptionConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModalOptionConfig.vue?vue&type=style&index=0&id=eca96e14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca96e14",
  null
  
)

export default component.exports